import { createI18n } from 'vue-i18n'

import { locales } from '@last/core-ui/paprika'

export const availableLocales = ['en', 'es', 'ca', 'de']

async function loadLocaleMessages(locale: string) {
  try {
    const messages = await import(`@/locales/${locale}.json`)
    return messages.default
  } catch {
    return {}
  }
}

function getBrowserLocale(): string {
  const browserLanguages = navigator.languages || [navigator.language]

  for (const browserLang of browserLanguages) {
    const langCode = browserLang.split('-')[0]
    const match = availableLocales.find(locale => locale === browserLang || locale === langCode)
    if (match) {
      return match
    }
  }

  return 'en'
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: getBrowserLocale(),
  fallbackLocale: 'en',
  messages: {}
})

export async function setI18nLanguage(locale: string) {
  if (!i18n.global.availableLocales.includes(locale)) {
    const messages = await loadLocaleMessages(locale)
    const coreMessages = locales[locale as keyof typeof locales] || {}

    i18n.global.setLocaleMessage(locale, {
      ...coreMessages,
      ...messages
    })
  }

  i18n.global.locale.value = locale
  document.querySelector('html')?.setAttribute('lang', locale)
  return locale
}

setI18nLanguage(getBrowserLocale())

export default i18n
